import {
  stringifyParams
} from 'helpers/query_params';

angular.module('gym.payouts').controller('PayoutsCtrl', ["$rootScope", "$scope", "$state", "ngTableParams", "EmploymentService", "Payouts", "loadingAnimation", function($rootScope, $scope, $state, ngTableParams, EmploymentService, Payouts, loadingAnimation) {
  var gym, permissions;
  gym = $rootScope.gym;
  permissions = EmploymentService.get().permissions;
  if (!gym.uses_gocardless || !permissions.view_payouts) {
    $state.go('gym.dashboard');
  }
  $scope.currency = gym.currency_symbol;
  $scope.filters = {};
  $scope.reload = function() {
    return $scope.tableParams.reload();
  };
  return $scope.tableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      var params;
      loadingAnimation.show();
      params = angular.extend(stringifyParams({
        filters: $scope.filters
      }), $params.url());
      return Payouts.getList(params).then(function(data) {
        $params.total(data.meta.total);
        loadingAnimation.hide();
        return $defer.resolve(data);
      });
    }
  });
}]);
